import { BaseProxy } from "@/proxies/BaseProxy";

export class ThreadProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `thread`,
      parameters,
    });
  }
}
